import { createFileRoute } from '@tanstack/react-router';
import LoginPage from '../Containers/LoginPage';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});
